import { useNavigate, useLocation } from 'react-router-dom'
import { House, Map, Radio, Store, Bookmark, User, LogIn, LogOut } from 'lucide-react'
import { useAuth } from '@/hooks/useAuth'

const C = { teal: '#0F5C5C', ink2: '#6D7471', border: '#E1E5E3', live: '#D85F5F' }
const FB = "'Inter', sans-serif"

const NAV = [
  { path: '/', icon: House, label: 'Inicio', live: false, protected: false },
  { path: '/map', icon: Map, label: 'Mapa', live: false, protected: false },
  { path: '/now', icon: Radio, label: 'Ahora', live: true, protected: false },
  { path: '/following', icon: Store, label: 'Siguiendo', live: false, protected: true },
  { path: '/saved', icon: Bookmark, label: 'Guardados', live: false, protected: true },
  { path: '/profile', icon: User, label: 'Perfil', live: false, protected: true },
]

interface Props {
  onNavigate?: () => void
}

export default function Sidebar({ onNavigate }: Props) {
  const { user, signOut } = useAuth()
  const navigate = useNavigate()
  const { pathname } = useLocation()

  const isActive = (p: string) => (p === '/' ? pathname === '/' : pathname.startsWith(p))

  const go = (path: string) => {
    navigate(path)
    onNavigate?.()
  }

  const btnStyle = (active: boolean): React.CSSProperties => ({
    display: 'flex',
    alignItems: 'center',
    gap: 12,
    padding: '10px 14px',
    borderRadius: 12,
    border: 'none',
    marginBottom: 3,
    width: '100%',
    textAlign: 'left',
    fontFamily: FB,
    fontSize: 14.5,
    background: active ? `${C.teal}14` : 'transparent',
    color: active ? C.teal : C.ink2,
    fontWeight: active ? 700 : 500,
    whiteSpace: 'nowrap',
    overflow: 'hidden',
  })

  return (
    <>
      {/* Ítems de navegación */}
      {NAV.map(({ path, icon: Icon, label, live, protected: prot }) => {
        const active = isActive(path)
        return (
          <button
            key={path}
            style={btnStyle(active)}
            onClick={() => {
              if (prot && !user) {
                go('/login')
                return
              }
              go(path)
            }}
          >
            <Icon size={20} color={active ? C.teal : C.ink2} style={{ flexShrink: 0 }} />
            <span className="sidebar-label">{label}</span>
            {live && (
              <span
                className="sidebar-badge"
                style={{
                  width: 7,
                  height: 7,
                  borderRadius: 99,
                  background: C.live,
                  marginLeft: 'auto',
                  animation: 'pxPulse 1.4s infinite',
                  flexShrink: 0,
                }}
              />
            )}
          </button>
        )
      })}

      {/* Footer */}
      <div style={{ marginTop: 'auto', paddingTop: 12, borderTop: `1px solid ${C.border}` }}>
        {user ? (
          <button
            style={btnStyle(false)}
            onClick={() => {
              signOut()
              onNavigate?.()
            }}
          >
            <LogOut size={20} color={C.ink2} style={{ flexShrink: 0 }} />
            <span className="sidebar-label">Cerrar sesión</span>
          </button>
        ) : (
          <button
            style={{
              ...btnStyle(false),
              background: `${C.teal}14`,
              color: C.teal,
              fontWeight: 700,
            }}
            onClick={() => go('/login')}
          >
            <LogIn size={20} color={C.teal} style={{ flexShrink: 0 }} />
            <span className="sidebar-label">Ingresar</span>
          </button>
        )}
      </div>
    </>
  )
}
